{
  "auth.login.title": "Mi9 Nexus",
  "auth.login.subtitle": "Sign in to manage your data transformations",
  "auth.login.usernameLabel": "Username",
  "auth.login.usernamePlaceholder": "Enter your username",
  "auth.login.usernameRequired": "Username is required",
  "auth.login.passwordLabel": "Password",
  "auth.login.passwordPlaceholder": "Enter your password",
  "auth.login.passwordRequired": "Password is required",
  "auth.login.forgotPassword": "Forgot password?",
  "auth.login.signingIn": "Signing in...",
  "auth.login.signIn": "Sign in",
  "auth.login.or": "or",
  "auth.login.hidePassword": "Hide password",
  "auth.login.showPassword": "Show password",
  "auth.login.dismissError": "Dismiss error",
  "auth.login.sessionExpired": "Your session has expired. Please sign in again.",
  "auth.login.ldaUnavailable": "Authentication service is temporarily unavailable. Please try again.",
  "auth.login.retry": "Retry",
  "auth.login.version": "v{{version}}",
  "auth.login.troubleSigningIn": "Having trouble signing in?",
  "auth.login.contactSupport": "Contact support",
  "auth.login.googleFailed": "Google sign-in failed. Please try again.",
  "auth.login.googleFailedGeneric": "Google sign-in failed",
  "auth.login.loginFailed": "Login failed",
  "auth.login.loginFailedDefault": "Login failed. Please check your credentials and try again.",
  "auth.login.reauthFailed": "Re-authentication failed",
  "auth.login.invalidPassword": "Invalid password",
  "auth.forgotPassword.title": "Mi9 Nexus",
  "auth.forgotPassword.subtitle": "Reset your password",
  "auth.forgotPassword.usernameRequired": "Email or username is required",
  "auth.forgotPassword.genericError": "Something went wrong. Please try again.",
  "auth.forgotPassword.checkEmail": "Check your email",
  "auth.forgotPassword.checkEmailDescription": "If an account exists for that username, you'll receive a password reset link shortly.",
  "auth.forgotPassword.backToSignIn": "Back to Sign in",
  "auth.forgotPassword.instructions": "Enter your email or username and we'll send you a password reset link. Make sure to enter it correctly — if it doesn't match an account, no email will be sent. If you don't see it within a few minutes, check your Spam or Junk folder.",
  "auth.forgotPassword.usernameLabel": "Email or Username",
  "auth.forgotPassword.usernamePlaceholder": "Enter your email or username",
  "auth.forgotPassword.sending": "Sending...",
  "auth.forgotPassword.sendResetLink": "Send reset link",
  "auth.forgotPassword.dismissError": "Dismiss error",
  "auth.forgotPassword.havingTrouble": "Having trouble?",
  "auth.forgotPassword.contactSupport": "Contact support",
  "auth.unauthorized.title": "Access Denied",
  "auth.unauthorized.noPermission": "You don't have permission to access this page.",
  "auth.unauthorized.currentRole": "Your current role is {{role}}.",
  "auth.unauthorized.goBack": "Go Back",
  "auth.unauthorized.goToSummary": "Go to Summary",
  "auth.unauthorized.signOut": "Sign out",
  "auth.unauthorized.needHelp": "Need help?",
  "auth.unauthorized.contactSupport": "Contact support",
  "auth.ldaModal.title": "Service Unavailable",
  "auth.ldaModal.description": "The authentication service is temporarily unavailable. Please try again in a moment.",
  "auth.ldaModal.retrying": "Retrying...",
  "auth.ldaModal.retryConnection": "Retry Connection",
  "auth.ldaModal.persistsContact": "If the problem persists, please contact support.",
  "dlq.tabs.transform": "Transform DLQ",
  "dlq.tabs.loader": "Loader DLQ",
  "dlq.tabs.skipped": "Skipped DLQ",
  "dlq.tabs.initialLoad": "Initial Load DLQ",
  "dlq.queueLabel.transform": "Transform",
  "dlq.queueLabel.loader": "Loader",
  "dlq.queueLabel.skipped": "Skipped",
  "dlq.queueLabel.initialLoad": "Initial Load",
  "dlq.actions.refresh": "Refresh",
  "dlq.actions.retry": "Retry",
  "dlq.actions.delete": "Delete",
  "dlq.actions.selectAll": "Select all messages",
  "dlq.actions.copyOriginalMessage": "Copy original message to clipboard",
  "dlq.actions.viewFullMessage": "View full message",
  "dlq.filter.mapping": "Mapping",
  "dlq.filter.allMappings": "All mappings",
  "dlq.filter.mappingId": "Mapping id {{id}}",
  "dlq.selection.summary": "of {{total}} selected",
  "dlq.footer.messagesInView_one": "{{count}} message in view",
  "dlq.footer.messagesInView_other": "{{count}} messages in view",
  "dlq.footer.total": "{{count}} total",
  "dlq.empty.noMessagesInRange": "No messages in selected time range",
  "dlq.empty.noMessagesInQueue": "No messages in queue",
  "dlq.empty.outsideRange_one": "There is {{count}} message in the {{queueType}} DLQ, but none within the last {{timeRange}}. Try selecting a longer time range.",
  "dlq.empty.outsideRange_other": "There are {{count}} messages in the {{queueType}} DLQ, but none within the last {{timeRange}}. Try selecting a longer time range.",
  "dlq.empty.queueEmpty": "The {{queueType}} DLQ is empty",
  "dlq.card.messageId": "Message ID",
  "dlq.card.error": "Error",
  "dlq.card.created": "Created",
  "dlq.card.attempts": "Attempts",
  "dlq.card.originalMessage": "Original Message",
  "dlq.card.errorContext": "Error Context",
  "dlq.card.stackTrace": "Stack Trace",
  "dlq.card.expandDetails": "Expand details",
  "dlq.tooltip.copyToClipboard": "Copy to clipboard",
  "dlq.tooltip.copied": "Copied!",
  "dlq.tooltip.openInPopup": "Open in popup",
  "dlq.purgeDialog.title": "Delete Messages",
  "dlq.purgeDialog.confirm_one": "Are you sure you want to permanently delete 1 selected message? This action cannot be undone.",
  "dlq.purgeDialog.confirm_other": "Are you sure you want to permanently delete {{count}} selected messages? This action cannot be undone.",
  "dlq.purgeDialog.cancel": "Cancel",
  "dlq.purgeDialog.deleting": "Deleting...",
  "dlq.notify.noRetailer.title": "No retailer selected",
  "dlq.notify.noRetailer.message": "Please select a retailer and environment before navigating.",
  "dlq.notify.noSelection.title": "No messages selected",
  "dlq.notify.noSelection.retryMessage": "Please select messages to retry",
  "dlq.notify.noSelection.purgeMessage": "Please select messages to purge",
  "dlq.notify.retrySuccess.title": "Messages retried",
  "dlq.notify.retrySuccess.message": "{{retried}} messages requeued, {{failed}} failed",
  "dlq.notify.retryFailed.title": "Retry failed",
  "dlq.notify.retryErrors.title": "Some messages were not retried",
  "dlq.replayDialog.title": "Retry Messages",
  "dlq.replayDialog.description_one": "Send 1 selected message to the pipeline again?",
  "dlq.replayDialog.description_other": "Send {{count}} selected messages to the pipeline again?",
  "dlq.replayDialog.overwriteWarning": "A retry writes the message's data to the target again. If the same row was changed and loaded after this message failed, the retry can overwrite the newer data. Loaded changes are not recorded, so this cannot be checked.",
  "dlq.replayDialog.checking": "Checking the DLQ for newer messages of the same rows...",
  "dlq.replayDialog.checkFailed": "The DLQ could not be checked for newer messages of the same rows: {{error}}",
  "dlq.replayDialog.mappingDeleted": "Its mapping (id {{mappingId}}) was deleted, so the retry of this message will fail.",
  "dlq.replayDialog.newerSameKey_one": "{{mapping}}: the DLQ has 1 newer message for the same row (primary key {{primaryKey}}). If you retry this older message, it can overwrite the newer change.",
  "dlq.replayDialog.newerSameKey_other": "{{mapping}}: the DLQ has {{count}} newer messages for the same row (primary key {{primaryKey}}). If you retry this older message, it can overwrite the newer changes.",
  "dlq.replayDialog.newerUnknownKey_one": "{{mapping}}: the DLQ has 1 newer message for the same mapping and table, and its row cannot be compared with this one. It can be a newer change of the same row.",
  "dlq.replayDialog.newerUnknownKey_other": "{{mapping}}: the DLQ has {{count}} newer messages for the same mapping and table, and their rows cannot be compared with this one. One of them can be a newer change of the same row.",
  "dlq.replayDialog.allMappings": "every active mapping of its table",
  "dlq.replayDialog.cancel": "Cancel",
  "dlq.replayDialog.pending": "Retrying...",
  "dlq.notify.purgeSuccess.title": "Messages purged",
  "dlq.notify.purgeSuccess.message": "{{purged}} messages removed",
  "dlq.notify.purgeFailed.title": "Purge failed",
  "dlq.messageViewer.title": "Original Message",
  "dlq.messageViewer.description": "Full JSON content of the original DLQ message with search functionality",
  "dlq.messageViewer.copyMessage": "Copy message to clipboard",
  "dlq.messageViewer.searchPlaceholder": "Search in message...",
  "dlq.messageViewer.matchCount": "{{current}} of {{total}}",
  "dlq.messageViewer.noMatches": "No matches",
  "dlq.messageViewer.previousMatch": "Previous match",
  "dlq.messageViewer.nextMatch": "Next match",
  "bulk.title": "Bulk Operations",
  "bulk.titleWithCount": "Export ({{count}})",
  "bulk.import": "Import",
  "bulk.export": "Export",
  "bulk.description": "Import or export mapping configurations",
  "bulk.importMappings": "Import Mappings",
  "bulk.exportMappings": "Export Mappings",
  "bulk.uploadJson": "Upload a JSON file",
  "bulk.downloadJson": "Download as JSON",
  "bulk.reviewImport": "Review Import",
  "bulk.reviewDescription": "Review the mappings before importing",
  "bulk.importComplete": "Import Complete",
  "bulk.importCompleteDescription": "Import operation completed",
  "bulk.uploadDescription": "Upload a JSON file containing mapping configurations",
  "bulk.exportDescription": "Configure export settings and download mappings",
  "bulk.exportOptions": "Export Options",
  "bulk.exportOptionsDescription": "Configure what to include in the export",
  "bulk.includeInactive": "Include inactive mappings",
  "bulk.selectMappings": "Select Mappings",
  "bulk.selectMappingsDescription": "Choose which mappings to export ({{count}} selected)",
  "bulk.exportAll": "Export all mappings",
  "bulk.exporting": "Exporting...",
  "bulk.exportCount_one": "Export {{count}} Mapping",
  "bulk.exportCount_other": "Export {{count}} Mappings",
  "bulk.noMappingsToExport": "No mappings available to export.",
  "bulk.exportListLoading": "Loading mappings…",
  "bulk.exportListUnavailable": "Could not load the mappings or their adapters. Retry to choose what to export.",
  "bulk.exportListRetry": "Retry",
  "bulk.importSuccessful": "Import Successful",
  "bulk.importWithIssues": "Import Completed with Issues",
  "bulk.totalProcessed": "Total Processed",
  "bulk.imported": "Imported",
  "bulk.skipped": "Skipped",
  "bulk.failed": "Failed",
  "bulk.importErrors": "Import Errors",
  "bulk.publicationWarningTitle": "Not added to CDC publication",
  "bulk.publicationWarning": "These tables were imported but could not be added to the Debezium publication. Run Sync Publication so CDC captures them.",
  "bulk.routeWarningTitle": "Imported as inactive with no route",
  "bulk.routeWarning": "The adapter configuration of these mappings does not route their target table. Add the route before you activate them.",
  "bulk.shadowFailureTitle": "Shadow table not built",
  "bulk.shadowFailure": "These multi-table mappings were imported, but their shadow table could not be built, so CDC does not capture their joined data. Fix the cause and save each mapping again.",
  "bulk.publicationRemovalFailedTitle": "Still in CDC publication",
  "bulk.publicationRemovalFailed": "These tables were deactivated but could not be removed from the Debezium publication. CDC is still capturing them. Run Sync Publication to reconcile.",
  "bulk.conflictCheckLoading": "Checking against saved mappings…",
  "bulk.conflictCheckUnavailable": "Could not load the saved mappings or their adapters, so active-state conflicts cannot be detected. Importing now could deactivate mappings and remove their tables from the CDC publication.",
  "bulk.conflictCheckRetry": "Retry",
  "bulk.conflictCheckTitle": "Active state not checked",
  "bulk.activeStateConflictTitle": "Active state differs from what is saved",
  "bulk.activeStateConflictDescription": "These mappings already exist and the file disagrees about whether they are active. Deactivating one removes its table from the Debezium publication, which stops CDC capturing changes — re-activating later resumes capture but does not recover the gap. Choose which value to apply.",
  "bulk.activeStateUseFile": "Use the file's values",
  "bulk.activeStateUseFileHint": "Apply what the file says. Mappings with no value become inactive.",
  "bulk.activeStateKeepCurrent": "Keep current active state",
  "bulk.activeStateKeepCurrentHint": "Import every other change but leave active state as it is today.",
  "bulk.activeStateSaved": "Saved",
  "bulk.activeStateInFile": "In file",
  "bulk.notSpecified": "Not specified",
  "bulk.totalMappings": "Total Mappings",
  "bulk.errors": "Errors",
  "bulk.warnings": "Warnings",
  "bulk.validationErrors": "Validation Errors",
  "bulk.preview": "Preview",
  "bulk.importing": "Importing...",
  "bulk.importCount_one": "Import {{count}} Mapping",
  "bulk.importCount_other": "Import {{count}} Mappings",
  "bulk.rules_one": "{{count}} rule",
  "bulk.rules_other": "{{count}} rules",
  "bulk.notifications.parseError": "Parse Error",
  "bulk.notifications.parseFailed": "Failed to parse file",
  "bulk.notifications.importFailed": "Import Failed",
  "bulk.notifications.importFailedMessage": "Failed to import mappings",
  "bulk.notifications.exportComplete": "Export Complete",
  "bulk.notifications.exportSuccess": "Mappings exported successfully",
  "bulk.notifications.exportFailed": "Export Failed",
  "bulk.notifications.exportFailedMessage": "Failed to export mappings",
  "mappings.notifications.initialLoadStarted": "Initial load started",
  "mappings.notifications.initialLoadStartedMessage": "The initial load process has been started for this mapping",
  "mappings.notifications.initialLoadFailed": "Failed to start initial load",
  "mappings.notifications.cancellationRequested": "Cancellation requested",
  "mappings.notifications.cancellationMessage": "The initial load cancellation has been requested",
  "mappings.notifications.cancelFailed": "Failed to cancel initial load",
  "mappings.notifications.deleted": "Mapping deleted",
  "mappings.notifications.deletedMessage": "The mapping has been permanently removed",
  "mappings.notifications.deleteFailed": "Failed to delete mapping",
  "mappings.notifications.paused": "Mapping paused",
  "mappings.notifications.activated": "Mapping activated",
  "mappings.notifications.toggleFailed": "Failed to update mapping status",
  "mappings.notifications.created": "Mapping created",
  "mappings.notifications.createdMessage": "The new mapping has been saved successfully",
  "mappings.notifications.updated": "Mapping updated",
  "mappings.notifications.updatedMessage": "Your changes have been saved",
  "mappings.notifications.saveFailed": "Failed to save mapping",
  "mappings.notifications.shadowTableFailed": "Shadow table setup failed",
  "mappings.notifications.shadowSyncFailed": "Shadow table sync failed",
  "mappings.notifications.deleteDialogFailed": "Delete Failed",
  "mappings.notifications.mappingDeleted": "Mapping Deleted",
  "mappings.notifications.mappingDeletedMessage": "The mapping and its data have been removed",
  "mappings.notifications.validationError": "Validation Error",
  "dashboard.noRetailer.title": "No retailer selected",
  "dashboard.noRetailer.description": "Select a retailer from the sidebar to view the pipeline dashboard",
  "dashboard.configNotLoaded.title": "Configuration not loaded",
  "dashboard.configNotLoaded.description": "Unable to determine the current environment",
  "dashboard.configNotLoaded.reload": "Reload",
  "dashboard.loadFailed.title": "Failed to load dashboard",
  "dashboard.loadFailed.defaultError": "An unexpected error occurred. Please try again.",
  "dashboard.loadFailed.retry": "Retry",
  "dashboard.serviceHealth": "Service Health",
  "dashboard.replicationSlot": "Replication Slot",
  "dashboard.replicationSlotStatus": "Replication slot status: {{status}}",
  "dashboard.debeziumCdc": "Debezium CDC Server",
  "dashboard.debeziumStatus": "Debezium status: {{status}}",
  "dashboard.debeziumStatusWithDetail": "Debezium status: {{status}}, {{detail}}",
  "dashboard.debeziumDetail.noProgress": "No progress for {{duration}}",
  "dashboard.debeziumDetail.slotMissing": "Replication slot missing",
  "dashboard.debeziumDetail.slotNotConnected": "Replication slot not connected",
  "dashboard.debeziumDetail.offsetsUnavailable": "Offsets table cannot be read",
  "dashboard.pipelineService": "Pipeline Service",
  "dashboard.pipelineStatus": "Pipeline status: {{status}}",
  "dashboard.viewLogs": "View Logs",
  "dashboard.viewLogsLabel": "View pipeline logs",
  "dashboard.activeMappings": "Active Mappings",
  "dashboard.ofMappings": "of {{total}} mappings",
  "dashboard.messagesPerMin": "Messages / min",
  "dashboard.dlqSection": "Dead Letter Queue",
  "dashboard.transformDlq": "Transform DLQ",
  "dashboard.loaderDlq": "Loader DLQ",
  "dashboard.skippedDlq": "Skipped DLQ",
  "dashboard.initialLoadDlq": "Initial Load DLQ",
  "dashboard.viewDlqDetails": "View {{title}} details",
  "dashboard.oldest": "Oldest: {{duration}}",
  "dashboard.telemetry": "Telemetry",
  "dashboard.chartError": "Failed to render chart",
  "monitoring.chartInfo": "Chart information",
  "monitoring.loading": "Loading...",
  "monitoring.noData": "No data available",
  "monitoring.timeRangeLabel": "Time range",
  "monitoring.showRange": "Show {{label}} range",
  "monitoring.throughput.title": "Throughput",
  "monitoring.throughput.description": "CDC event processing rate: received, transformed, and loaded events per minute",
  "monitoring.throughput.eventsPerMin": "{{count}} events/min",
  "monitoring.throughput.received": "Received",
  "monitoring.throughput.transformed": "Transformed",
  "monitoring.throughput.loaded": "Loaded",
  "monitoring.throughput.srLatest": "Latest throughput: {{received}} received, {{transformed}} transformed, {{loaded}} loaded events per minute.",
  "monitoring.throughput.srLabel": "Throughput chart showing received, transformed, and loaded events per minute over time",
  "monitoring.errorRate.title": "Error Rate",
  "monitoring.errorRate.description": "Percentage of CDC events that failed during transformation. 5% threshold shown as reference line",
  "monitoring.errorRate.errorRate": "{{rate}}% error rate",
  "monitoring.errorRate.failedOfTotal": "{{failed}} failed / {{total}} total",
  "monitoring.errorRate.srLabel": "Error rate chart showing transformation failure percentage over time",
  "monitoring.errorRate.srLatest": "Latest error rate: {{rate}}% with {{failed}} failed of {{total}} total events.",
  "monitoring.latency.title": "Latency Percentiles",
  "monitoring.latency.description": "Processing latency at p50/p95/p99 for transformation and load stages",
  "monitoring.latency.transformP50": "Transform p50",
  "monitoring.latency.transformP95": "Transform p95",
  "monitoring.latency.transformP99": "Transform p99",
  "monitoring.latency.loadP50": "Load p50",
  "monitoring.latency.loadP95": "Load p95",
  "monitoring.latency.loadP99": "Load p99",
  "monitoring.latency.srLabel": "Latency percentiles chart showing p50, p95, and p99 for transformation and load stages",
  "monitoring.latency.srLatest": "Latest transformation latency: p50={{p50}}, p95={{p95}}, p99={{p99}}.",
  "monitoring.latency.noData": "no data",
  "monitoring.dlqTrend.title": "DLQ Message Trend",
  "monitoring.dlqTrend.description": "Dead letter queue depth over time across transform, loader, skipped, and initial load queues",
  "monitoring.dlqTrend.transform": "Transform",
  "monitoring.dlqTrend.loader": "Loader",
  "monitoring.dlqTrend.skipped": "Skipped",
  "monitoring.dlqTrend.initialLoad": "Initial Load",
  "monitoring.prometheus.unreachable": "Prometheus unreachable",
  "monitoring.prometheus.unavailable": "Metrics data source is unavailable",
  "monitoring.pipelineLogs.title": "Pipeline Logs",
  "monitoring.pipelineLogs.windowTitle": "Pipeline Logs — Nexus",
  "monitoring.pipelineLogs.connected": "Connected",
  "monitoring.pipelineLogs.disconnected": "Disconnected",
  "monitoring.pipelineLogs.pipelineOffline": "Pipeline offline",
  "monitoring.pipelineLogs.reconnecting": "Reconnecting...",
  "monitoring.pipelineLogs.loadingHistory": "Loading history...",
  "monitoring.pipelineLogs.connecting": "Connecting to pipeline...",
  "monitoring.pipelineLogs.toggleSearch": "Toggle search",
  "monitoring.pipelineLogs.searchHint": "Search (Ctrl+F)",
  "monitoring.pipelineLogs.clearTerminal": "Clear terminal",
  "monitoring.pipelineLogs.clear": "Clear",
  "monitoring.pipelineLogs.searchPlaceholder": "Search logs...",
  "monitoring.pipelineLogs.previousMatch": "Previous match",
  "monitoring.pipelineLogs.previousHint": "Previous (Shift+Enter)",
  "monitoring.pipelineLogs.nextMatch": "Next match",
  "monitoring.pipelineLogs.nextHint": "Next (Enter)",
  "monitoring.pipelineLogs.pipelineOfflineOverlay": "Pipeline service is offline",
  "monitoring.pipelineLogs.footerShowing": "Showing logs from a single pipeline instance",
  "monitoring.pipelineLogs.footerSearch": "Ctrl+F search",
  "mappings.empty.title": "No mappings found",
  "mappings.empty.searchHint": "Try adjusting your search",
  "mappings.empty.createHint": "Create your first mapping to get started",
  "mappings.empty.newMapping": "New Mapping",
  "mappings.table.selectAll": "Select all mappings",
  "mappings.table.selectMapping": "Select mapping {{name}}",
  "mappings.table.sourceTable": "Source Table",
  "mappings.table.targetTable": "Target Table",
  "mappings.table.fields": "Fields",
  "mappings.table.status": "Status",
  "mappings.table.initialLoad": "Initial Load",
  "mappings.table.version": "Version",
  "mappings.table.userUpdated": "User Updated",
  "mappings.table.lastUpdated": "Last Updated",
  "mappings.table.multiTableMapping": "Multi-table mapping:",
  "mappings.table.primary": "(primary)",
  "mappings.table.clickToPause": "Click to pause",
  "mappings.table.clickToActivate": "Click to activate",
  "mappings.table.active": "Active",
  "mappings.table.paused": "Paused",
  "mappings.table.deleteMapping": "Delete mapping {{name}}",
  "mappings.table.deleteTooltip": "Delete",
  "mappings.table.rowMenu": "Actions for {{name}}",
  "mappings.table.adapterConfig": "Adapter",
  "mappings.table.noAdapterConfig": "Not set",
  "mappings.table.noAdapterConfigHint": "This mapping sends no data until you open it and choose an adapter configuration.",
  "mappings.loadError.title": "Failed to load mappings",
  "mappings.loadError.description": "Something went wrong while fetching your mappings",
  "mappings.loadError.retry": "Retry",
  "mappings.search.placeholder": "Search mappings...",
  "mappings.filter.activeOnly": "Active only",
  "mappings.actions.refresh": "Refresh",
  "mappings.deleteDialog.title": "Delete Mapping",
  "mappings.deleteDialog.description": "Are you sure you want to permanently delete the mapping for {{name}} ? This action cannot be undone.",
  "mappings.deleteDialog.cancel": "Cancel",
  "mappings.deleteDialog.deleting": "Deleting...",
  "mappings.deleteDialog.delete": "Delete",
  "mappings.initialLoad.triggered": "Initial load started",
  "mappings.initialLoad.triggeredMessage": "Initial load triggered for {{key}}",
  "mappings.initialLoad.triggerFailed": "Failed to trigger load",
  "mappings.cancelLoad.requested": "Cancellation requested",
  "mappings.cancelLoad.message": "The job will stop at the next checkpoint",
  "mappings.cancelLoad.failed": "Failed to cancel load",
  "mappings.resumeLoad.requested": "Resume requested",
  "mappings.resumeLoad.message": "The job continues from its last checkpoint",
  "mappings.resumeLoad.failed": "Failed to resume load",
  "mappings.editor.breadcrumbMappings": "Mappings",
  "mappings.editor.breadcrumbNew": "New Mapping",
  "mappings.editor.notFound": "Mapping not found",
  "mappings.editor.loadFailed": "Failed to load mapping: {{message}}",
  "mappings.editor.backToMappings": "Back to Mappings",
  "mappings.editor.noRetailer.title": "No retailer selected",
  "mappings.editor.noRetailer.description": "Select a retailer from the sidebar before creating a new mapping",
  "mappings.editor.configNotLoaded.title": "Configuration not loaded",
  "mappings.editor.configNotLoaded.description": "Unable to determine the current environment",
  "mappings.editor.configNotLoaded.reload": "Reload",
  "mappings.editor.new": "New",
  "mappings.editor.saving": "Saving...",
  "mappings.editor.save": "Save",
  "mappings.editor.delete": "Delete",
  "mappings.editor.schema": "Schema",
  "mappings.editor.onDelete": "On Delete",
  "mappings.editor.deleteStrategy.skip": "Skip",
  "mappings.editor.deleteStrategy.soft": "Soft Delete",
  "mappings.editor.deleteStrategy.hard": "Hard Delete",
  "mappings.editor.adapterConfig": "Adapter",
  "mappings.editor.adapterConfigPlaceholder": "Select adapter",
  "mappings.editor.adapterConfigLoading": "Loading...",
  "mappings.editor.adapterConfigEmpty": "No adapters exist for this retailer and environment",
  "mappings.editor.adapterConfigLoadFailed": "Failed to load adapters",
  "mappings.editor.adapterConfigChangedInactive": "Adapter configuration changed",
  "mappings.editor.adapterConfigChangedInactiveMessage": "The mapping is inactive, so no initial load was started. To copy the existing rows to the new adapter configuration, activate the mapping and start an initial load from the mappings list.",
  "mappings.editor.adapterConfigRequired": "Select the adapter this mapping sends its data through",
  "mappings.editor.adapterType.database": "Database",
  "mappings.editor.adapterType.http_api": "HTTP API",
  "mappings.editor.adapterType.file": "File",
  "mappings.editor.joinHint": "Use the link button on source table headers to define join relationships",
  "mappings.editor.tableConfig": "Table Configuration",
  "mappings.editor.sourceTableLabel": "Source Table",
  "mappings.editor.selectTable": "Select table",
  "mappings.editor.loadingTables": "Loading...",
  "mappings.editor.tableHint": "Nexus database table name",
  "mappings.editor.loadingColumns": "Loading columns...",
  "mappings.editor.columnsError": "Failed to load columns",
  "mappings.editor.addSourceTable": "Add Source Table",
  "mappings.editor.otherCategory": "Other",
  "mappings.editor.mappingCount_one": "{{count}} mapping",
  "mappings.editor.mappingCount_other": "{{count}} mappings",
  "mappings.editor.modified": "Modified",
  "mappings.editor.unsavedDialog.title": "Unsaved Changes",
  "mappings.editor.unsavedDialog.description": "You have unsaved changes. Leaving now will discard them.",
  "mappings.editor.unsavedDialog.stay": "Stay",
  "mappings.editor.unsavedDialog.leave": "Leave Anyway",
  "mappings.editor.changeSourceDialog.title": "Change Source Table?",
  "mappings.editor.changeSourceDialog.description": "Changing the source table will reset all mappings and target columns. This action cannot be undone.",
  "mappings.editor.changeSourceDialog.cancel": "Cancel",
  "mappings.editor.changeSourceDialog.continue": "Continue",
  "mappings.editor.activePipelineDialog.title": "Modify Active Shadow Table?",
  "mappings.editor.activePipelineDialog.description": "This mapping is actively processing CDC events. Saving it alters its shadow table and refills it from the source tables. Writes to the source tables wait while that runs, and the shadow table is out of change streaming meanwhile, so the refilled rows and any change made in that time are not sent to the target. When the refill changes rows, the editor offers an initial load after the save, which sends every shadow table row to the target.",
  "mappings.editor.activePipelineDialog.cancel": "Cancel",
  "mappings.editor.activePipelineDialog.proceed": "Proceed",
  "mappings.editor.deleteDialog.title": "Delete Mapping?",
  "mappings.editor.deleteDialog.description": "This will permanently delete the mapping for \"{{table}}\". This action cannot be undone.",
  "mappings.editor.deleteDialog.cancel": "Cancel",
  "mappings.editor.deleteDialog.deleting": "Deleting...",
  "mappings.editor.deleteDialog.delete": "Delete",
  "mappings.editor.validation.targetRequired": "Target table name is required",
  "mappings.editor.validation.fieldRequired": "At least one field mapping is required",
  "mappings.editor.validation.joinRequired": "Multi-table mappings require at least one join between source tables",
  "mappings.editor.validation.joinCycle": "Join graph contains a cycle. Remove redundant joins to create a tree structure.",
  "mappings.editor.validation.keyRule": "Each primary key column must map to its own target field through a one-to-one or normalization rule from the primary table (no '.' in the target field, no normalization default value unless throwOnUnmapped is true).",
  "mappings.editor.validation.keyUnmapped": "Unmapped: {{columns}}.",
  "mappings.editor.validation.keyAmbiguous": "Ambiguous: {{columns}}.",
  "mappings.editor.validation.reservedTargetField": "Target field '{{field}}' is reserved: the HTTP adapter sets it on every row to 'create', 'update' or 'delete'. Rename the target field.",
  "mappings.editor.validation.keyColumnsMissing": "The primary table has no primary key columns, so the mapping has no write key.",
  "mappings.editor.saveFailed": "Failed to save mapping",
  "mappings.editor.created": "Mapping created",
  "mappings.editor.createdMessage": "Mapping for {{table}} has been created",
  "mappings.editor.shadowTableFailed": "Shadow table setup failed",
  "mappings.editor.shadowTableFailedMessage": "Mapping saved, but shadow table creation failed. CDC may not capture joined data. Check server logs.",
  "mappings.editor.updated": "Mapping updated",
  "mappings.editor.updatedMessage": "Mapping for {{table}} has been updated",
  "mappings.editor.noRouteTitle": "Saved as inactive: no route for the target table",
  "mappings.editor.noRouteMessage": "{{warning}}. Add the route to the adapter configuration before you activate this mapping.",
  "mappings.editor.shadowSyncFailed": "Shadow table sync failed",
  "mappings.editor.shadowSyncFailedMessage": "Mapping saved, but CDC may not capture joined data. Check server logs. {{error}}",
  "mappings.editor.shadowCleanupFailed": "Shadow table cleanup failed",
  "mappings.editor.shadowCleanupFailedMessage": "Mapping saved. {{error}}",
  "mappings.editor.deleteFailed": "Delete Failed",
  "mappings.editor.deleteFailedMessage": "Failed to delete mapping",
  "mappings.editor.deleted": "Mapping Deleted",
  "mappings.editor.deletedMessage": "Mapping for \"{{table}}\" has been deleted",
  "mappings.editor.togglePaused": "Mapping paused",
  "mappings.editor.togglePausedMessage": "Mapping for {{table}} has been paused",
  "mappings.editor.toggleActivated": "Mapping activated",
  "mappings.editor.toggleActivatedMessage": "Mapping for {{table}} has been activated",
  "mappings.editor.toggleFailed": "Failed to update mapping",
  "mappings.editor.toggleFailedMessage": "Mapping for {{table}} status update failed",
  "mappings.editor.deletedMappingMsg": "Mapping for {{table}} has been deleted"
}
